/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconTower: {
  name: 'tower';
  data: string;
} = {
  name: 'tower',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M541.773 586.708 507.467 475.737 460.426 475.737 460.426 250.236 533.527 159.616 533.527 26.792 456.521 26.792 456.521 89.442 409.647 89.442 409.647 26.792 331.804 26.792 331.804 89.442 285.769 89.442 285.769 26.792 207.926 26.792 207.926 89.442 161.89 89.442 161.89 26.792 84.884 26.792 84.877 26.792 84.877 159.616 157.978 250.236 157.978 475.737 110.938 475.737 76.632 586.708z"/></svg>`,
};
